<!-- The (appTaskContextMenuOpenSubtask) binding below is dead: the menu stopped emitting it when
     "Add details" began opening the full form itself. -->
<div
  class="flex flex-col rounded px-8 cursor-grab hover:bg-secondary-100"
  [ngClass]="{
    'gap-5 py-6': !subtask,
    'py-2 h-20 justify-center': subtask,
    'bg-white': !task.completed,
    'bg-secondary-200': task.completed,
  }"
  appDraggable
  [appDraggableDisabled]="dragging"
  [appDraggableData]="dragData"
  [appDraggablePlaceholder]="dragPlaceholder"
  (appDraggableDraggingChanged)="isDragging = $event"
  appDroppable
  appDroppableHoverClass="outline-2 outline-dashed outline-blue-200 outline-offset-[-2px]"
  [appDroppableDisabled]="dragging"
  [appDroppablePredicate]="dndPredicate"
  [appDroppableZIndex]="1"
  (appDroppableDrop)="dndDrop($event)"
  [appTaskContextMenu]="task"
  [appTaskContextMenuBoard]="true"
  (appTaskContextMenuOpenTask)="openInDP()"
  (appTaskContextMenuOpenSubtask)="openSubtask.emit($event)"
  (appDblClick)="openInModal()"
  (appClick)="openInDP()"
>
  <div class="flex items-center gap-6 min-w-0">
    <app-circular-progress
      [progress]="task.progress"
      [size]="20"
      [priority]="task.priority"
      [completed]="task.completed"
      (onClick)="handleComplete()"
    />

    <!--This section is hidden for V1-->
    @if (false) {
      <span class="whitespace-nowrap text-secondary-500">
        {{ task | taskIssueKeyTitle }}
      </span>
    }

    <div
      class="min-w-0 flex-1 text-base font-semibold"
      [class.truncate]="subtask"
      [class.whitespace-normal]="!subtask"
      [class.break-words]="!subtask"
      [class.text-secondary-1000]="!task.completed"
      [class.line-through]="task.completed"
      [class.text-secondary-700]="task.completed"
    >
      {{ task.title }}
    </div>
  </div>

  @if (!subtask) {
    <div class="flex items-center gap-4 text-sm text-secondary-650">
      <span class="whitespace-nowrap">
        {{ !task.startDateTime ? 'No Start Date' : '' }}
        {{ task.startDateTime | dateFormat: 'monthDay' : undefined : true : startDateZone }}
        @if (task | stitchDisplayTime: 'start'; as startTime) {
          , {{ startTime | dateFormat: 'timeShort' | lowercase }}
        }
      </span>
      <span class="h-6 w-px bg-secondary-300"></span>
      <span [class.text-error]="isOverdue()" class="whitespace-nowrap">
        {{ !task.endDateTime ? 'No Due Date' : '' }}
        {{ task.endDateTime | dateFormat: 'monthDay' : undefined : true : endDateZone }}
        @if (task | stitchDisplayTime: 'end'; as endTime) {
          , {{ endTime | dateFormat: 'timeShort' | lowercase }}
        }
      </span>
    </div>
  }
</div>

<ng-template #dragPlaceholder>
  <app-board-task class="drag-placeholder" [task]="task" [subtask]="subtask" [dragging]="true" />
</ng-template>
